import React from 'react';
import PropTypes from 'prop-types';

import { ChipStyled, StyledInput, StyledLabel, ElementWrapper } from './styled';
import { StyledViewByDevice } from 'components/atoms/ViewByDevice/styled';

const Chip = ({ id, label, active, disabled, onClick, error, onlyNative = false, checkBorder }) => {
  const localId = `checkbox_${id}`;
 
  if (onlyNative) {
    return (
      <ElementWrapper>
        <StyledInput failed={error} checkBorder={checkBorder} id={localId} checked={active} disabled={disabled} onChange={onClick} type='checkbox' />
        <StyledLabel disabled={disabled} checkBorder={checkBorder} failed={error} htmlFor={localId}>{label}</StyledLabel>
      </ElementWrapper>
    );
  }

  return (
    <>
      <StyledViewByDevice variant='mobile' style={{ justifyContent: 'center' }}>
        <ChipStyled
          role='presentation'
          onClick={onClick}
          active={active}
          disabled={disabled}
          failed={!!error}
          checkBorder={checkBorder}
        >
          {label}
        </ChipStyled>
      </StyledViewByDevice>
      <StyledViewByDevice varaint='desktop'>
        <ElementWrapper>
          <StyledInput failed={error} checkBorder={checkBorder} id={localId} checked={active} disabled={disabled} onChange={onClick} type='checkbox' />
          <StyledLabel disabled={disabled} checkBorder={checkBorder} failed={error} htmlFor={localId}>{label}</StyledLabel>
        </ElementWrapper>
      </StyledViewByDevice>
    </>
  );
};

Chip.propTypes = {
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  label: PropTypes.string,
  active: PropTypes.bool,
  disabled: PropTypes.bool,
  onClick: PropTypes.func,
  onlyNative: PropTypes.bool,
};

export default Chip;
